/**
 * Catálogo dos 15 mapas de região (1 por faixa de nível).
 * Bands 11–14 reusam a arte de supreme-threshold como placeholder.
 * Sincronizar com public/assets/world/world-map-manifest.json (ferramentas Node).
 */
/** Bump when map art files change (cache bust no browser). */
export const WORLD_MAP_ART_VERSION = '20260721-02';

export const WORLD_MAP_MANIFEST = Object.freeze({
  version: 1,
  canvas: Object.freeze({ width: 1000, height: 620 }),
  hub: Object.freeze({ x: 50, y: 50 }),
  maps: Object.freeze([
    Object.freeze({
      band: 0,
      level: 1,
      slug: 'saffron-meadows',
      file: 'world-region-00-saffron-meadows.webp',
      wireframe: 'world-region-00-wireframe.webp',
      title: 'Saffron Meadows',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 1,
      level: 10,
      slug: 'viridian-trail',
      file: 'world-region-01-viridian-trail.webp',
      wireframe: 'world-region-01-wireframe.webp',
      title: 'Viridian Trail',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 2,
      level: 20,
      slug: 'pewter-forest',
      file: 'world-region-02-pewter-forest.webp',
      wireframe: 'world-region-02-wireframe.webp',
      title: 'Pewter Forests',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 3,
      level: 40,
      slug: 'pewter-woods',
      file: 'world-region-03-pewter-woods.webp',
      wireframe: 'world-region-03-wireframe.webp',
      title: 'Pewter Woods',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 4,
      level: 60,
      slug: 'rock-tunnel-swamp',
      file: 'world-region-04-rock-tunnel-swamp.webp',
      wireframe: 'world-region-04-wireframe.webp',
      title: 'Rock Tunnel Swamps',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 5,
      level: 80,
      slug: 'rock-tunnel-caves',
      file: 'world-region-05-rock-tunnel-caves.webp',
      wireframe: 'world-region-05-wireframe.webp',
      title: 'Rock Tunnel Caves',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 6,
      level: 100,
      slug: 'cinnabar-volcano',
      file: 'world-region-06-cinnabar-volcano.webp',
      wireframe: 'world-region-06-wireframe.webp',
      title: 'Cinnabar Volcano',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 7,
      level: 150,
      slug: 'cinnabar-ashes',
      file: 'world-region-07-cinnabar-ashes.webp',
      wireframe: 'world-region-07-wireframe.webp',
      title: 'Cinnabar Ashes',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 8,
      level: 200,
      slug: 'sevii-islands',
      file: 'world-region-08-sevii-islands.webp',
      wireframe: 'world-region-08-wireframe.webp',
      title: 'Legendary Isles',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 9,
      level: 250,
      slug: 'glacial-sea',
      file: 'world-region-09-glacial-sea.webp',
      wireframe: 'world-region-09-wireframe.webp',
      title: 'Glacial Sea',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 10,
      level: 300,
      slug: 'supreme-threshold',
      file: 'world-region-10-supreme-threshold.webp',
      wireframe: 'world-region-10-wireframe.webp',
      title: 'Supreme Threshold',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 11,
      level: 350,
      slug: 'ashen-spire',
      file: 'world-region-10-supreme-threshold.webp',
      wireframe: 'world-region-10-wireframe.webp',
      title: 'Ashen Spire',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 12,
      level: 400,
      slug: 'obsidian-court',
      file: 'world-region-10-supreme-threshold.webp',
      wireframe: 'world-region-10-wireframe.webp',
      title: 'Obsidian Court',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 13,
      level: 450,
      slug: 'eclipse-rift',
      file: 'world-region-10-supreme-threshold.webp',
      wireframe: 'world-region-10-wireframe.webp',
      title: 'Eclipse Rift',
      hubLabel: 'Saffron City',
    }),
    Object.freeze({
      band: 14,
      level: 500,
      slug: 'final-horizon',
      file: 'world-region-10-supreme-threshold.webp',
      wireframe: 'world-region-10-wireframe.webp',
      title: 'Final Horizon',
      hubLabel: 'Saffron City',
    }),
  ]),
});

/** 15 faixas → 5 tiles de hunt OTBM (route-*-r0..4). */
export const ROUTE_ART_TIER_BY_BAND = Object.freeze([
  0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4,
]);

export function worldMapEntry(band) {
  const i = Math.max(0, Math.min(WORLD_MAP_MANIFEST.maps.length - 1, Number(band) || 0));
  return WORLD_MAP_MANIFEST.maps[i];
}

export function routeArtTier(band) {
  const i = Math.max(0, Math.min(ROUTE_ART_TIER_BY_BAND.length - 1, Number(band) || 0));
  return ROUTE_ART_TIER_BY_BAND[i] ?? 0;
}
